import { Component, Signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';

const API_KEY = 'AIzaSyAofBuw5aPFX5fSqufqidgwY1kjdeP5DAA'

@Component({
    selector: 'app-c-google-maps',
    imports: [],
    templateUrl: './c-google-maps.component.html',
    styleUrl: './c-google-maps.component.scss'
})
export class CGoogleMapsComponent {

  #cid: string | null;
  #url: string | null;
  public mapUrl: SafeResourceUrl;
  
  constructor(
    private websiteState: WebsiteStateService,
    private sanitizer: DomSanitizer
  ) {
    this.#cid = this.websiteState.configuration().shopId;
    this.#url = `https://www.google.com/maps/embed/v1/place?q=place_id:${this.#cid}&key=${API_KEY}`;
    this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.#url);
  }

  public ccAccepted$: Signal<boolean> = this.websiteState.ccAccepted;

}
